/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { View as BackboneView } from 'backbone';
import PropTypes from 'prop-types';
import { FocusLock } from '@bingads-webui-react/focus-lock';
import { BackboneViewWrapper } from '@bingads-webui-react/backbone-view-wrapper';

export const FocusLockBackboneWrapper = ({
  focusLockProps, View, viewOptions, eventsToActions,
}) => (
  <FocusLock {...focusLockProps}>
    <BackboneViewWrapper
      View={View}
      options={viewOptions}
      eventsToActions={eventsToActions}
    />
  </FocusLock>);

FocusLockBackboneWrapper.propTypes = {
  focusLockProps: PropTypes.object,
  View: PropTypes.oneOfType([BackboneView]).isRequired,
  viewOptions: PropTypes.object,
  eventsToActions: PropTypes.arrayOf(PropTypes.shape({
    event: PropTypes.string.isRequired,
    action: PropTypes.func.isRequired,
  })),
};

FocusLockBackboneWrapper.defaultProps = {
  focusLockProps: {},
  viewOptions: {},
  eventsToActions: [],
};
